import { render, staticRenderFns } from "./editSAAYCJE.vue?vue&type=template&id=31c0b196&scoped=true&"
import script from "./editSAAYCJE.vue?vue&type=script&lang=js&"
export * from "./editSAAYCJE.vue?vue&type=script&lang=js&"
import style0 from "./editSAAYCJE.vue?vue&type=style&index=0&id=31c0b196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c0b196",
  null
  
)

export default component.exports